import { LOGOUT } from './../../auth/actions/auth.actions';
import * as systemLoaderActions from '../actions/system-loader.actions';

export const systemLoaderFeatureKey = 'systemLoader';

export interface ISystemLoaderState {
  activeProcesses: string[];
  numActiveProcesses: number;
}

export const initialState: ISystemLoaderState = {
  activeProcesses: [],
  numActiveProcesses: 0
};


export function systemLoaderReducer(state: ISystemLoaderState = initialState, action: any): ISystemLoaderState {
  switch (action.type) {
    case systemLoaderActions.SHOW_SPINNER:
      const isActionAlreadyInProgress = state.activeProcesses
        .filter((currentAction: any) =>
          currentAction === action.payload.type)
        .length;
      // We only store one instance of any single action type in the actions in progress array.
      // This is done because it often happens that multiple actions with the same types are fired simultaneously.
      // Meaning: Multiple actions are made to request some data, but only one call is actually made to the backend for example,
      // which would result in only one action being fired when request has returned data.
      // This would mean a discrepency in actions that reflect processes being in progress and processes being finished.


      if (isActionAlreadyInProgress) {
        return state;
      }

      const newActionsInProgress = [
        ...state.activeProcesses,
        action.payload.type
      ];

      return {
        ...state,
        numActiveProcesses: newActionsInProgress.length,
        activeProcesses: newActionsInProgress
      };
    case systemLoaderActions.HIDE_SPINNER:
      const triggerAction = action.payload?.triggerAction;
      let newActionsInProgressWhenHiding = [];
      if (triggerAction) {
        if (triggerAction !== LOGOUT) {
          newActionsInProgressWhenHiding = state.activeProcesses.filter((currentAction: any) => currentAction !== action.payload.triggerAction);
        }
      } else {
        newActionsInProgressWhenHiding = state.activeProcesses;
      }

      return {
        ...state,
        numActiveProcesses: newActionsInProgressWhenHiding.length,
        activeProcesses: newActionsInProgressWhenHiding
      };
    default:
      return state;
  }
}

